import { Select } from 'antd';
import { useEffect } from 'react';

import { VFlex } from '@/components/base';
import { CHART_CALCULATION } from '@/entities/chart/model/constants';
import useChartStateAction from '@/features/(charts)/chart-controller/hooks/use-chart-state-action/useChartStateAction';
import { useChartMetricPolicy } from '@/features/(charts)/chart-metric-policy';
import { calculationEnabledMetricList } from '@/features/(charts)/chart-renderer/lib/conditions';
import { ChartCalculationMap } from '@/features/(charts)/chart-renderer/model/chart-maps';

type Props = {
  chartInfo: ChartContextProps;
  seriesIndex: number;
};

const ChartMetricSelect = (props: Props) => {
  const { chartInfo, seriesIndex } = props;
  const { state } = chartInfo;
  const { onMetricChange, onCalculationChange } =
    useChartStateAction(chartInfo);
  const { metricOptions, getSafeMetric } = useChartMetricPolicy();
  const selectedMetric = getSafeMetric(state.series[seriesIndex].measure.metric);

  useEffect(() => {
    if (state.series[seriesIndex].measure.metric === selectedMetric) {
      return;
    }

    onMetricChange(selectedMetric, seriesIndex);
  }, [onMetricChange, selectedMetric, seriesIndex, state.series]);

  const availableCalculationOptions = ChartCalculationMap.toArray().filter(
    (item) => item.value !== CHART_CALCULATION.COUNT,
  );

  return (
    <VFlex g={12}>
      <Select
        options={metricOptions}
        value={selectedMetric}
        onChange={(metric) => onMetricChange(metric, seriesIndex)}
      />
      {calculationEnabledMetricList.includes(selectedMetric) && (
        <Select
          options={availableCalculationOptions}
          value={state.series[seriesIndex].measure.calculation}
          onChange={(calculation) =>
            onCalculationChange(calculation, seriesIndex)
          }
        />
      )}
    </VFlex>
  );
};

export default ChartMetricSelect;
